import type { Directive } from 'vue'
import { createPermDirective } from '@uc/auth-sdk'
import { usePermStore } from '@/stores/perm'

/**
 * `v-perm="'order:approve'"`：按钮级权限（附录C §2）。
 * 菜单只负责导航可见性，操作级控制由本指令完成；指令直接移除 DOM，不依赖样式隐藏。
 */
export const vPerm: Directive<HTMLElement, string | string[]> = createPermDirective((code) =>
  usePermStore().has(code),
)
